/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HealthSummary } from './HealthSummary';
import type { UserDto } from './UserDto';

export type GetDataProductListResponseDto = {
    assetCount: number;
    dataProductStatus: GetDataProductListResponseDto.dataProductStatus;
    dataProductUpstreamStatus: GetDataProductListResponseDto.dataProductUpstreamStatus;
    description?: string;
    healthSummary: HealthSummary;
    id: string;
    name: string;
    owners: Array<UserDto>;
    sla?: string;
};

export namespace GetDataProductListResponseDto {

    export enum dataProductStatus {
        HEALTHY = 'HEALTHY',
        AT_RISK = 'AT_RISK',
        CRITICAL = 'CRITICAL',
    }

    export enum dataProductUpstreamStatus {
        HEALTHY = 'HEALTHY',
        AT_RISK = 'AT_RISK',
        CRITICAL = 'CRITICAL',
    }


}
